import { ButtonModel } from 'Pages/knowledge'
import { FrontUrls } from 'Constants/FrontUrls'

export const DEFAULT_FILE_NAME = 'filename.mp4'
export const SIZE_VIDEO = {
	MIN_WIDTH: 1280,
	MIN_HEIGHT: 720,
}

export const toolbarBtns: ButtonModel[] = [
	{
		id: 'new_project',
		icon: 'new-project',
		url: FrontUrls.knowledge.project_create,
	},
	{
		id: 'new_article',
		icon: 'new-article',
		url: FrontUrls.knowledge.article_create,
	},
	{
		id: 'new_video',
		icon: 'new-video',
		url: FrontUrls.knowledge.video_create,
	},
]

export const CREATE_ACCESS = ['knowledge_article.create', 'knowledge_project.create']
